import store from '../store'

export default {
  install (Vue) {
    // 计算页面高度
    Vue.prototype.HEIGHT_VIEW = () => {
      // 用window。innerHeight除以获取html高度算出高度给元素
      let height = parseFloat(document.documentElement.style.fontSize)
      let winInnHeight = window.innerHeight
      let sum = winInnHeight / height
      store.dispatch('SET_INNER_HEIGHT_REM', sum)
    }
    Vue.prototype.getQueryString = (name) => {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
    // 抽奖奖品展示的角度方法
    Vue.prototype.getRote = (len, i) => {
      return 90 + (360 / len) * i
    }
    Vue.prototype.getRote2 = (len, i) => {
      return ((360 / len) / 2) + (360 / len) * i
    }
    Vue.prototype.getRote3 = (len) => {
      return 90 - (360 / len)
    }
    Vue.prototype.IsPC = () => {
      let userAgentInfo = navigator.userAgent
      let Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
      let flag = true
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false
          break
        }
      }
      return flag
    }
  }
}
